import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import ui from './modules/ui'
// import basket from './modules/basket'
import appData from './modules/appData'
import user from './modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    state: {
        appName: process.env.VUE_APP_NAME || "hafta8",
        seatIOPublicKey: process.env.VUE_APP_SEAT_IO_PUBLIC_KEY,
        websiteAddress: process.env.VUE_APP_EMAIL_VERIFICATION_CONTINUE_URL || 'https://hafta8.com',
    },
    mutations: {

    },
    actions: {
        
    },
    modules: {
        auth,
        ui,
        appData,
        user,
    },
    strict: debug,
})